var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 91,
    viewBox: "0 0 190 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_811",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 190,
    height: 91
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 0H0V91H190V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_811)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 182,
    height: 81
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 64.5C20.25 64.5 43.25 73 70 62.25C96.75 51.5 99.125 45.375 103.625 39C108.125 32.625 104.5 22.125 95.5 23.625C86.5 25.125 78.875 32.875 80.75 39.75C82.625 46.625 83.75 49.5 88.25 52.625C92.75 55.75 101.5 61.375 116.125 58.875C130.75 56.375 153.375 44 165.875 34.375",
    stroke: "white",
    strokeWidth: 36,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.308 39.883C144.351 53.633 113.125 70.494 91.81 58.591C83.833 53.88 80.519 50.684 78.259 42.2C76.289 31.28 88.84 18.76 99.84 20.6C109.344 22.185 110.537 34.567 105.529 41.34C102.085 47.97 90.996 56.484 85.6 58.69C70.02 67.49 53.39 71.93 35.38 70.21C31.86 69.773 20.273 68.723 20.629 64.14C21.06 62.8 22.34 63.41 23.28 63.35C32.795 64.721 42.304 65.604 51.85 64.05C65.785 62.261 78.85 55.974 90.6 48.22C95.824 44.051 101.872 38.789 102.42 31.72C102.47 27.75 100.31 25.96 96.36 26.52C90.03 27.44 83.61 33.65 83.65 39.74C85.08 48.637 96.336 55.943 105.14 56.499C122.328 57.162 143.296 47.577 156.63 36.77C152.08 36.03 147.25 35.277 143.54 33.75C139.83 32.223 140.704 27.987 144.81 29.14C151.59 30.35 158.4 31.22 165.32 31.23C169.27 31.24 170.76 33.44 169.23 36.96C166.44 43.37 163.094 49.379 160.174 55.729C159.324 57.579 158.076 60.203 155.756 59.173C153.206 58.053 154.694 55.196 155.594 53.216C157.584 48.866 160.629 42.367 161.308 39.883Z",
    fill: "#221F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.a1876983e53002f90c08242503b684ce.svg";
export { ForwardRef as ReactComponent };